var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useMemo, useRef } from 'react';
import { C } from '#integrations';
import { revealInScrollBox } from '#services';
import { ArrowNavigationMenu } from './components/ArrowNavigationMenu';
import { MenuContext } from './context';
import { MenuTestIdFactory } from './interactions';
import styles from './Menu.module.css';
export const Menu = ({ children, 'data-testid': testId, isScrollable, navigationType, shouldKeepActiveInView = false, }) => {
    _react_refresh_temp_2();
    const listRef = useRef(null);
    const revealItem = useCallback((item) => {
        if (!shouldKeepActiveInView || !listRef.current || !item) {
            return;
        }
        revealInScrollBox(listRef.current, item);
    }, [shouldKeepActiveInView]);
    const contextValue = useMemo(() => ({ revealItem }), [revealItem]);
    return navigationType === 'tabs' ? (_jsx("ul", { className: C(styles.Container, isScrollable && styles.Scrollable), "data-testid": MenuTestIdFactory.getMenuListTestId(testId || ''), ref: listRef, role: "menu", children: _jsx(MenuContext.Provider, { value: contextValue, children: children }) })) : (_jsx(ArrowNavigationMenu, { children: children }));
};
_react_refresh_temp_1 = Menu;
$RefreshReg$(_react_refresh_temp_1, "Menu");
_react_refresh_temp_2(Menu, "mxQJrLundeWmuCU5DcKIF4buSG0=");
